module.exports = __webpack_public_path__ + "static/media/icon_selected_table.09036e2f.svg";